import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles } from "../../styles/theme";
import { BuildContext } from "../../context/BuildSpotlightState";
import TextContent from "./preview/TextContent";
import AudioContent from "./preview/AudioContent";

const BuildPreview = () => {
  const { primaryColor, type } = useContext(BuildContext);

  return (
    <div className={container} style={{ backgroundColor: primaryColor }}>
      {type === "text" ? <TextContent /> : <AudioContent />}
    </div>
  );
};

export default BuildPreview;

const container = css`
  height: 60px;
  padding: ${boxStyles.standardPadding};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0px 5px 9px rgba(0,0,0,.2);
`;
